export default "__VITE_ASSET__BMMSwwYL__"